export const windowStartingSize = {
  height: 400,
  width: 700
}

export const windowTopLimit = 0
export const windowsBottomLimit = 30
export const windowLeftLimit = 150
export const windowRightLimit = 100
export const windowsMinHeight = 200
export const windowsMinWidth = 200
export const defaultAlertDuration = 1000 * 10

export const DESKTOP_PAGES = {
  MENU: 'MENU'
}

export const windowMinWidth = 1280
export const scrollWidth = 20
